import React from 'react';
import '../../../App.css';
import withStyles from "@material-ui/core/styles/withStyles";
import MaterialTable from 'material-table';
import { withCookies } from "react-cookie";
import { routePermissions } from "../../auth/network/Login";
import { bundleUpdate } from "../network/Authwalls";
import { get as getResources } from "../network/Resources";
import { get as getFeatures } from "../network/Features";
import { exportToExcel } from "../util/exportExcel";
import { Form, Card, Message, Upload } from 'shineout'

const service = 'uploader';
// const path = ['m', 'u'];
const path = 'a';
const UPLOAD_URL = '/lm/v1/uploader/a';
const styles = theme => ({
    theme: theme,
    root: {
        display: 'wrap',
    },
    container: {
        display: 'block',
        flexWrap: 'wrap',
    },
    fab: {
        margin: theme.spacing(1),
    },
    box: {
        component: 'div',
        display: 'inline',
        flexWrap: 'wrap',
    },
    card: {
        padding: theme.spacing(1),
        margin: theme.spacing(2),
    },
    textField: {
        margin: 8,
        padding: theme.spacing(1),
        width: 200,
    },
    media: {
        paddingTop: '56.25%',
    }
});

class BundleUpdate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                { title: 'EMAC', field: 'emac' },
                { title: 'MBOARD', field: 'mboard' },
                { title: 'SERIAL NO', field: 'serialno' },
                { title: 'MODEL', field: 'model' },
                { title: 'BRAND', field: 'brand' },
                { title: 'FEATURE', field: 'feature' },
                { title: 'STATE', field: 'state' },
                { title: 'DESCRIPTION', field: 'description' },
                { title: 'FACTORY', field: 'factory' },
                { title: 'VENDOR', field: 'vendor' },
            ],
            // Every field the server sends for a skipped MAC — same list drives the
            // table and the Excel download, so they can never drift apart.
            skippedColumns: [
                { title: 'EMAC', field: 'emac' },
                { title: 'CURRENT STATE', field: 'current_state' },
                { title: 'CURRENT BRAND', field: 'current_brand' },
                { title: 'CURRENT VENDOR', field: 'current_vendor' },
                { title: 'CURRENT FACTORY', field: 'current_factory' },
                { title: 'CURRENT BOARD', field: 'current_board' },
                { title: 'CURRENT MODEL', field: 'current_model' },
                { title: 'CURRENT DESCRIPTION', field: 'current_description' },
                { title: 'CURRENT OWNER', field: 'current_user' },
                { title: 'FILE SERIAL NO', field: 'serialno' },
                { title: 'FILE DESCRIPTION', field: 'description' },
                { title: 'REASON', field: 'error' },
            ],
            data: [],
            policy: JSON.parse(this.props.cookies.cookies.policy),
            xlsx_data: [],
            skippedExisting: [],
            table: '',
            isLoading: true,
            POST: false,
            GET: false,
            PUT: false,
            DELETE: false,
        };
    }

    componentWillMount() {
        routePermissions(this.props, { service: service, path: path }, result => {
            console.log(result)
            if (result === null) {
                Message.error('No permission to access this route', 3, { position: 'bottom-right' });
            } else {
                result.map(method => {
                    this.setState({ [method.name]: true })
                    this.setState({ [method.name + '_DATA']: method.resources })
                })
                if (this.state.POST) {
                    getResources({ type: 'brand' }, (data) => {
                        console.log(data)
                        var brands = [];
                        data.map(brand_element => {
                            brands.push(brand_element.name)
                            this.setState({ brands: brands })
                        })
                    })
                    getResources({ type: 'mboard' }, (data) => {
                        console.log(data)
                        var boards = [];
                        data.map(board_element => {
                            boards.push(board_element.name)
                            this.setState({ boards: boards })
                        })
                    })
                    getResources({ type: 'attribute' }, (data) => {
                        console.log(data)
                        var attributes = [];
                        data.map(attribute_element => {
                            attributes.push(attribute_element.name)
                            this.setState({ attributes: attributes })
                        })
                    })
                    getFeatures({}, (data) => {
                        console.log('FEATURES ADDED------->' + data)
                        console.log(data)
                        var features = [];
                        data.map(features_element => {
                            features.push(features_element.name)
                            this.setState({ features: features })
                        })
                        /*
                        data.map(e => features.push(e.name))
                        this.setState({ features: features })
                        */
                    });

                }
            }
        })
    }

    // Excel of the MACs Bundle Update left untouched, same columns as the table.
    downloadSkipped = (rows) => {
        const list = rows || this.state.skippedExisting;
        if (!list || list.length === 0) {
            Message.error('Nothing to download', 3, { position: 'bottom-right' });
            return;
        }
        const name = `bundle_update_skipped_${new Date().toISOString().slice(0, 10)}.xlsx`;
        if (exportToExcel(name, this.state.skippedColumns, list))
            Message.success(`${list.length} skipped MAC(s) downloaded`, 4, { position: 'bottom-right' });
        else
            Message.error('Failed to generate the Excel file', 4, { position: 'bottom-right' });
    }

    render() {
        return (
            <React.Fragment >
                <Card fullWidth>
                    <Card.Header>Bundle Update</Card.Header>
                    {this.state.POST ? <Card.Body>
                        <Form
                            scrollToError={30}
                            onSubmit={data => {
                                var request_data = {
                                    state: '1',
                                    description: '',
                                    emacs: this.state.xlsx_data
                                }
                                console.log(request_data)
                                bundleUpdate(request_data, (status, body) => {
                                    if (status) {
                                        const skipped = (body && body.skipped_existing) || 0;
                                        Message.success(
                                            `${(body && body.inserted) || 0} MAC(s) inserted, ` +
                                            `${(body && body.updated) || 0} overwritten` +
                                            (skipped ? `, ${skipped} left untouched` : ''),
                                            5, { position: 'bottom-right' });
                                    } else {
                                        Message.error(
                                            (body && body.message) || 'Failed updating data. Try again',
                                            5, { position: 'bottom-right' });
                                    }

                                })
                            }}>
                            <Upload
                                action={UPLOAD_URL}
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                name="file"
                                // headers={{ Authorization: 'Bearer ' + this.state.token }}
                                params={{ brand: this.state.brands, board: this.state.boards, features: this.state.features, attribute: this.state.attributes }}
                                htmlName={'file'}
                                limit={1}
                                renderResult={f => f}
                                onSuccess={(res, file, data) => {
                                    res = JSON.parse(res);
                                    console.log(res);
                                    if (res.errorCode) {
                                        if (res.errorCode >= 105) {
                                            this.setState({ data: res.data })
                                            this.setState({
                                                table: <MaterialTable
                                                    title={res.errorMessage + '!! Fix entries below to continue'}
                                                    columns={this.state.columns}
                                                    data={this.state.data}
                                                    onRowClick={(event, rowData, toggleDetailPanel) => {
                                                        console.log(rowData)
                                                    }}
                                                    options={{
                                                        pageSize: res.data.length < 100 ? res.data.length : 100,
                                                        pageSizeOptions: [50, 100, 200,500],
                                                        actionsColumnIndex: 100,
                                                    }}
                                                />
                                            })
                                            return new Error()
                                        }else if(res.errorCode == 103){
                                            this.setState({ table: '' })
                                            return new Error(res.errorMessage)
                                        }
                                         else {
                                            this.setState({ table: '' })
                                            return new Error(res.errorMessage)
                                        }
                                    } else {
                                        // Bundle Update upserts: STATE 0/1/2 overwrites the existing entry,
                                        // a MAC with no entry is inserted. Anything listed below is untouched.
                                        const fresh   = res.valid_rows || res;
                                        const skipped = res.skipped_existing || [];
                                        this.setState({
                                            xlsx_data: fresh,
                                            data: [],
                                            skippedExisting: skipped,
                                            table: skipped.length === 0 ? '' : <MaterialTable
                                                title={`${skipped.length} MAC(s) already exist with a STATE other than 0, 1 or 2 — they will NOT be touched`}
                                                columns={this.state.skippedColumns}
                                                data={skipped}
                                                actions={[{
                                                    icon: 'get_app',
                                                    tooltip: 'Download this list as Excel',
                                                    isFreeAction: true,
                                                    onClick: () => this.downloadSkipped(skipped),
                                                }]}
                                                options={{
                                                    search: true,
                                                    searchFieldAlignment: 'right',
                                                    pageSize: Math.min(skipped.length, 100),
                                                    pageSizeOptions: [50, 100, 200, 500],
                                                    actionsColumnIndex: 100,
                                                    headerStyle: { backgroundColor: '#fff3e0', color: '#e65100' },
                                                }}
                                            />,
                                        })
                                        return `Data parsed. ${fresh.length} MAC(s) will be inserted/overwritten` +
                                               (skipped.length ? `, ${skipped.length} untouched` : '')
                                    }

                                }}
                                validator={
                                    {
                                        ext: ext => (['xls', 'xlsx'].includes(ext) ?
                                            undefined :
                                            new Error('File extension must be xls or xlsx')),
                                    }
                                }>
                                <Upload.Dragger>
                                    <i className="material-icons">cloud_upload</i>
                                    <br />
                                    Click or Drag application to upload
                                    <br />
                                    Upload Excel file
                                </Upload.Dragger>
                            </Upload>
                        </Form>
                        {this.state.table}
                    </Card.Body> : ''}
                    <Card.Footer>
                        <div style={{ textAlign: 'left' }}>
                            Download XLSX file template <a href="/template_update.xlsx">here</a>
                        </div>
                        {this.state.POST ? <Card.Submit
                            style={{
                                position: 'absolute',
                                top: 8,
                                right: 100,
                            }}
                        >Submit</Card.Submit> : ''}
                    </Card.Footer>
                </Card>
            </React.Fragment >
        );
    }
}

export default withStyles(styles)(withCookies(BundleUpdate));
